import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import routes from '../routes'
import { SIZES } from '../styles/theme'
import { Link, useLocation, useParams } from 'react-router-dom'

import PageWithBg from '../components/PageWithBg'
import Amplitude from '../utils/amplitudeHelper'
import { onDemand, categories } from '../constants/galleriumVideos'
import VideoOnDemandModal from '../components/GlobalModals/VideoOnDemandModal'
import LoadIcon from '../components/LoadIcon'
import CategorisedVideos from '../components/CategorisedVideos'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { toast } from 'react-toastify'

const Page = styled.div`
  .full {
    position: absolute;
    padding-top: ${SIZES.navHeight};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;

    .sidenavs {
      height: 100%;
      width: 25%;
      display: flex;
      text-align: center;
      color: white;
      .page-title {
        font-weight: 600;
        width: 80%;
        font-size: 1.25em;
        align-self: center;
        padding-bottom: 60px;
      }
    }
    .search-wrapper {
      width: 35%;
      height: 40px;
      background-color: #fff;
      border: solid 3px #FFD421;
      border-radius: 30px;
      padding: 0px 10px 0px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-input {
        width: 90%;
        font-size: 14px;
        border: none;
      }
      .search-icon {
        height: 20px;
      }
    }

    .main {
      width: 75%;
      /* backdrop-filter: blur(15px); */
      background-color: rgba(255, 255, 255, 0.4);
      padding: 32px 56px;
      padding-right: 72px;
      height: 100%;
      overflow-y: scroll;

      .cat-title {
        font-weight: 600;
        font-size: 24px;
        padding: 0;
        text-decoration: underline;
        margin-top: 28px;
      }
      .listing {
        .infographic {
          background: white;
          width: 275px;
          margin-right: 16px;
          margin-bottom: 32px;
          cursor: pointer;
          position: relative;
          
          .overlay {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100%;
            width: 100%;
            opacity: 0;
            transition: .5s ease;
            background-color: rgba(255, 255, 255, 0.3);
            backdrop-filter: blur(4px);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .gallery-btn {
              background-color: transparent;
              border: none;
              font-size: 18px;
              width: 85%;
              margin: 4px auto;
              font-weight: 600;
              color: #26B4A9;
              text-align: center;
              
              svg {
                width: 28px;
                margin-right: 6px;
              }
              &:hover {
                color: #3A2D86;
                path {
                  fill: #3A2D86;
                  stroke: #3A2D86;
                }
                svg, g {
                  stroke: #3A2D86;
                }
              }
            }
          }
          &:hover .overlay {
            opacity: 1;
          }
          .image {
            display: block;
            width: 100%;
            height: auto;
          }
        }
      }
      .toggle-back {
        font-weight: bold;
        color: #FFD421;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        text-decoration: none;
        .back-prev {
          display: flex;
          width: 30px;
          flex-direction: column;
          img, svg {
            transition: 100ms linear;
            height: 24px;
          }
          .icon-label {
            transition: 100ms linear;
            text-align: left;
            font-size: 1px;
            opacity: 0;
          }
          &:hover {
            img, svg {
              transform: scale(0.5);
            }
            .icon-label {
              font-size: 8px;
              opacity: 1;
            }
          }
        }
        span {
          font-size: 24px;
          font-style: italic;
          margin-left: 1em;
          color: #FFB831;
        }
      }
    }
  }
`

export default function PosterGalleryPage({ currentUser }) {
  const { category } = useParams()
  const location = useLocation()
  const [gallery, setGallery] = useState(null)
  const [content, setContent] = useState(null)
  const [videoOpen, setVideoOpen] = useState(false)
  const [videos, setVideos] = useState(null)
  const [searchInput, setSearchInput] = useState('')

  useEffect(() => {
    let filtered = onDemand.filter(
      (mat) => mat.destination === location.pathname
    )
    setGallery(filtered[0])
    setVideos(filtered[0].videos)
  }, [])
  
  useEffect(() => {
    Amplitude.visit(`On-Demand: ${category}`)
  }, [currentUser.id])

  const showModal = (item) => {
    Amplitude.playVOD(category, item.title)
    if (item.link === "" && gallery.name === "Invited Presentations") {
      toast("Video not available now. Please try later.")
    } 
    else if (item.link === "" && gallery.name !== "Invited Presentations") {
      window.open(item.form, "_blank")
    }
    else {
      setContent(item)
      setVideoOpen(true)
    }
  }

  const onChangeSearchInput = (e) => {
    setSearchInput(e.target.value)
    if (e.target.value !== '') {
      const updated = gallery.videos.filter((item) =>
        new RegExp(e.target.value.toLowerCase()).test(item.title.toLowerCase())
      )
      setVideos(updated)
    } else {
      setVideos(gallery.videos)
    }
  }

  return (
    <Page>
      <PageWithBg bgImg={config.assets.gallerium}>
        {
          gallery ? 
            <>
              <section className="full">
                <div className="sidenavs">
                  <span className="page-title">On-Demand</span>
                </div>
                <div className="main">
                  <div className="d-flex justify-content-between align-items-center">
                    <Link to={routes.onDemand} className="toggle-back">
                      <div className="back-prev">
                        <svg width="17.301" height="26.839" viewBox="0 0 17.301 26.839">
                          <g transform="translate(17.301 26.839) rotate(180)">
                            <path d="M.459,14.462,13.147,26.407a1.637,1.637,0,0,0,2.216,0l1.48-1.393a1.415,1.415,0,0,0,0-2.084L6.79,13.419,16.845,3.909a1.415,1.415,0,0,0,0-2.084L15.363.432a1.637,1.637,0,0,0-2.216,0L.459,12.376A1.415,1.415,0,0,0,.459,14.462Z" transform="translate(17.301 26.839) rotate(180)" fill="#ffd421"/>
                          </g>
                        </svg>
                        <small className="icon-label">Back</small>
                      </div>
                      <span>{gallery.name}</span>
                    </Link>
                    <div className="search-wrapper">
                      <input
                        value={searchInput}
                        onChange={onChangeSearchInput}
                        type="text"
                        placeholder="Search"
                        className="search-input"
                      />
                      <svg width="22.111" height="21.113" viewBox="0 0 22.111 21.113">
                        <g transform="translate(2.113)">
                          <g transform="translate(2.998)" fill="none" stroke="#FFB831" strokeWidth="3">
                            <circle cx="8.5" cy="8.5" r="8.5" stroke="none"/>
                            <circle cx="8.5" cy="8.5" r="7" fill="none"/>
                          </g>
                          <path d="M8081-7186l-6,5" transform="translate(-8075.002 7200)" fill="none" stroke="#FFB831" strokeLinecap="round" strokeWidth="3"/>
                        </g>
                      </svg>
                    </div>
                  </div>
                  {
                    gallery.name === "Invited Presentations" ? (
                      <>
                        {videos.filter(vid => vid.category === categories[0]).length > 0 && <CategorisedVideos category={categories[0]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[1]).length > 0 && <CategorisedVideos category={categories[1]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[2]).length > 0 && <CategorisedVideos category={categories[2]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[3]).length > 0 && <CategorisedVideos category={categories[3]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[4]).length > 0 && <CategorisedVideos category={categories[4]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[5]).length > 0 && <CategorisedVideos category={categories[5]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[6]).length > 0 && <CategorisedVideos category={categories[6]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[7]).length > 0 && <CategorisedVideos category={categories[7]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[8]).length > 0 && <CategorisedVideos category={categories[8]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[9]).length > 0 && <CategorisedVideos category={categories[9]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[10]).length > 0 && <CategorisedVideos category={categories[10]} videos={videos} showModal={showModal} />}
                        {videos.filter(vid => vid.category === categories[11]).length > 0 && <CategorisedVideos category={categories[11]} videos={videos} showModal={showModal} />}
                      </>
                    ) :
                    <div className="d-flex flex-wrap listing my-5">
                      {videos.map((item, index) =>
                        <LazyLoadComponent key={`video-${index}`}>
                          <div className="infographic" onClick={() => showModal(item)}>
                            <img className="image" src={item.thumbnail} alt={`video-${index}`} />
                            <div className="overlay">
                              <button className="gallery-btn">
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#26b4a9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <polygon points="10 8 16 12 10 16 10 8"></polygon>
                                </svg>
                                Play Video
                              </button>
                            </div>
                          </div>
                        </LazyLoadComponent>
                      )}
                    </div>
                    
                  }

                </div>
              </section>
              {videoOpen && <VideoOnDemandModal cat={category} videoOpen={videoOpen} setVideoOpen={setVideoOpen} content={content} showTitle={gallery.name === "Invited Presentations"} />}
            </>
          :
          <LoadIcon />
        }
      </PageWithBg>
    </Page>
  )
}
